export const ENERGY_PRICE_COLOR_SCHEMES = {
	scheme1: 'linear-gradient(96.828deg, rgb(0, 141, 255) 0.78813%, rgb(87, 59, 255) 67.701%)',
} as const;

export type ColorSchemeKey = keyof typeof ENERGY_PRICE_COLOR_SCHEMES;

const STORAGE_KEY = 'shelly_energy_price_color_scheme';

export const energyPriceColorSchemes = {
	schemes: ENERGY_PRICE_COLOR_SCHEMES,

	getCurrentScheme(): ColorSchemeKey {
		try {
			const saved = localStorage.getItem(STORAGE_KEY);
			if (saved && saved in ENERGY_PRICE_COLOR_SCHEMES) {
				return saved as ColorSchemeKey;
			}
		} catch (err) {
			console.error('Failed to read color scheme from localStorage:', err);
		}
		return 'scheme1';
	},

	setCurrentScheme(scheme: ColorSchemeKey): void {
		try {
			localStorage.setItem(STORAGE_KEY, scheme);
		} catch (err) {
			console.error('Failed to save color scheme to localStorage:', err);
		}
	},
};
